import { FC } from "react";
import { OptionProps, components } from "react-select";
import { OptionItem } from "../../Dropdown/OptionItem";
import { HighlightedMatches } from "./HighlightMatches";

/**
 * A single option within the select.
 */
export const Option: FC<OptionProps<OptionItem | null>> = (props) => {
  const { data, selectProps } = props;
  const { inputValue } = selectProps;
  const label = data?.label?.toString() ?? "";

  return (
    <components.Option {...props}>
      <HighlightedMatches text={label} query={inputValue ?? ""}/>
    </components.Option>
  );
};
